<template>
  <div class="liked-product" :class="cls">
    <div class="liked-product-img"><img :src="imgLink" /></div>
    <div class="liked-product-info">
      <h1 class="liked-product-name">{{ product['name_' + lang] }}</h1>
      <div class="liked-product-list-price">&euro; {{ listPrice }}</div>
      <div class="liked-product-price">&euro; {{ price }}</div>
      <a class="liked-product-link" :href="link" @click="track" target="_blank"
        >{{ $root.__('view product') }} &rarr;</a
      >
    </div>
  </div>
</template>

<script>
import { envReplace, refParam } from '../util.js'

export default {
  props: {
    context: String,
    product: null
  },
  computed: {
    cls() {
      return {
        'product--promo': this.listPrice > this.price
      }
    },
    price() {
      return parseFloat(this.product.price)
    },
    lang() {
      return this.$root.state.lang || 'nl'
    },
    listPrice() {
      return parseFloat(this.product.list_price)
    },
    link() {
      return refParam(envReplace(this.product['link_' + this.lang]))
    },
    imgLink() {
      return envReplace(this.product.img_link)
    }
  },
  methods: {
    track() {
      this.$root.track({
        event_type: 'click_on_recommendation',
        action_item: this.product.product,
        page_type: 'dreambuddy',
        list_name: this.product.list_name,
        request_id: `${this.product.request_id}`
      })
    }
  }
}
</script>

<style>
.liked-product {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  padding: 10px 0;
  overflow: hidden;
}
.liked-product:first-child {
  border-top: 0;
}
.liked-product-img {
  float: left;
  width: 50px;
  height: 50px;
}
.liked-product-img > img {
  display: block;
  width: 50px;
  height: 50px;
  object-fit: contain;
  object-position: center;
}
.liked-product-info {
  position: relative;
  margin-left: 70px;
}
.liked-product-name {
  margin: 0;
  font-size: 16px;
  line-height: 1.2em;
  max-height: 2.4em;
  overflow: hidden;
}
.liked-product-list-price {
  display: none;
}
.liked-product-price {
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  color: #696e80;
}
.liked-product-link {
  display: inline-block;
  position: absolute;
  bottom: -0.4em;
  right: -1rem;
  padding-right: 1rem;
  font-size: 12px;
  line-height: 2em;
  text-decoration: underline;
  color: #08abfc;
}
.product--promo .liked-product-list-price {
  display: block;
  margin: 0;
  text-decoration: line-through;
  color: #000;
  opacity: 0.4;
  font-size: 12px;
  line-height: 1.2em;
}
.product--promo .liked-product-price {
  color: #a62f2f;
}
</style>
